import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useAddPlan = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePostFn(ENDPOINTS.ADD_PLAN, data),
    {
      onSuccess: async () => {
        // Invalidate the specific query to refetch plans
        queryClient.invalidateQueries([ENDPOINTS.GET_PLANS]);
      },
    }
  );
};
